<template>
  <div>
    <Header />
    <Landing class="section" />
    <Aboutme class="section" />
    <Skills class="section" />
    <whatIdo class="section" />
    <Blogs class="section" />
    <Testimonials />
    <Contactme class="section" />
    <Footer />
    <Navbar />

  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Landing from "@/components/landing.vue";
import Aboutme from "@/components/aboutMe.vue";
import Skills from "@/components/skills.vue";
import whatIdo from "@/components/whatIdo.vue";
import Blogs from "@/components/blogs.vue";
import Testimonials from "@/components/testimonial.vue";
import Contactme from "@/components/contact.vue";
import Footer from "@/components/footer.vue";
import Navbar from "@/components/navbar.vue";

export default {
  components: {
    Header,
    Landing,
    Aboutme,
    Skills,
    whatIdo,
    Blogs,
    Testimonials,
    Contactme,
    Footer,
    Navbar,
  },
  data(){
      return {
      // isDarkMood: true,
    };
  },
  mounted() {
    let items = document.querySelectorAll(".test");
    let sections = document.querySelectorAll(".section");
    window.addEventListener("scroll", () => {
      let current = "";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        if (pageYOffset > sectionTop - sectionHeight / 3) {
          current = section.getAttribute("id");
        }
      });
      items.forEach((item) => {
        item.classList.remove("active");
        if (item.classList.contains(current)) {
          item.classList.add("active");
        }
      });
    });
  },
   created() {
    //  console.log(this.$root.isDarkMood)
    // let darkMode = localStorage.getItem("darkMode");
    // if (darkMode == "true" || darkMode == null) {
    //   if (darkMode == null) {
    //     this.isDarkMood = true;
    //     localStorage.setItem("darkMode", false);
    //   }
    //   if (darkMode == "true") {
    //     document.body.style.backgroundColor = "rgba(255 , 255, 255, 0.4)";
    //     this.isDarkMood = false;
    //   }
    // } else if (darkMode == "false") {
    //   this.isDarkMood = true;
    // }
  },
};
</script>

<style>
</style>